import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import BCTuyencodinhtable from "components/Tonghopbaocao/Hoatdongvantai/BCTuyencodinhtable.js";
import BCXehopdongtable from "components/Tonghopbaocao/Hoatdongvantai/BCXehopdongtable.js";
import BCXebuyttable from "components/Tonghopbaocao/Hoatdongvantai/BCXebuyttable.js";
import BCVantaitable from "components/Tonghopbaocao/Hoatdongvantai/BCVantaitable.js";
import BCBenxekhachtable from "components/Tonghopbaocao/Hoatdongvantai/BCBenxekhachtable.js";
import BCBenxehangtable from "components/Tonghopbaocao/Hoatdongvantai/BCBenxehangtable.js";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import Config from "conFig.js";
const Bchoatdongvantaict = React.memo(function Bchoatdongvantaict(props) {
  const classes = useStyles();
  const { thangnam, thaydoidexuat } = props;
  const [data, setData] = React.useState({});
  const [khokhan, setKhokhan] = React.useState("");
  const [dexuat, setDexuat] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/Phuongtien/bcpl21sgtvt?thang=" +
        thang +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setData(data[0]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  const getkhokhandexuat = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/Canhbao/getbckhokhandexuatthang?thang=" +
        thang +
        "&baocao_id=4" +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setKhokhan(data[0].khokhan);
            setDexuat(data[0].dexuat);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
    getkhokhandexuat();
  }, [thangnam, thaydoidexuat]);
  return (
    <GridContainer>
      <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
      <GridItemLogin xs={12} sm={12} md={8}>
        <GridContainer style={{ border: "0.1px solid #4f7edb" }}>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%" }}>
              <a className={classes.tieudecenter}>
                BÁO CÁO TÌNH HÌNH HOẠT ĐỘNG VẬN TẢI NĂM {" " + thangnam.$y}
              </a>
              <a className={classes.tieudecenter}>
                (Ban hành kèm theo Thông tư số 36/2024/TT-BGTVT ngày 15 /11/2024
                của Bộ trưởng Bộ Giao thông vận tải)
              </a>
              <a className={classes.tieudeleftbold}>
                1. Kết quả hoạt động vận chuyển hành khách
              </a>
              <a className={classes.tieudeleft}>
                a) Vận chuyển hành khách liên tỉnh theo tuyến cố định:
              </a>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <BCTuyencodinhtable data={data} />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <a className={classes.tieudeleft}>
              b) Vận chuyển hành khách theo hợp đồng:
            </a>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <BCXehopdongtable data={data} />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <a className={classes.tieudeleft}>
              c) Vận chuyển hành khách bằng xe buýt:
            </a>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <BCXebuyttable data={data} />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <a className={classes.tieudeleftbold}>
              2. Kết quả hoạt động vận tải hàng hóa
            </a>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <BCVantaitable data={data} />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <a className={classes.tieudeleftbold}>
              3. Kết quả hoạt động của các bến xe trên địa bàn
            </a>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <a className={classes.tieudeleft}>a) Bến xe khách</a>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <BCBenxekhachtable data={data} />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <a className={classes.tieudeleft}>b) Bến xe hàng</a>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <BCBenxehangtable data={data} />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <a className={classes.tieudeleftbold}>
              4. Thuận lợi, khó khăn: {khokhan}
            </a>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <a className={classes.tieudeleftbold}>
              5. Đề xuất, kiến nghị: {dexuat}
            </a>
          </GridItem>
        </GridContainer>
      </GridItemLogin>
      <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
    </GridContainer>
  );
});

Bchoatdongvantaict.propTypes = {
  thangnam: PropTypes.object,
  thaydoidexuat: PropTypes.number,
};
export default Bchoatdongvantaict;
